/* Project Moss — Product card AJAX add to cart */
(function () {
  'use strict';

  /* AJAX add-to-cart */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-moss-atc]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var id = btn.dataset.variantId;
    if (!id) return;

    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓';
        /* Trigger Dawn cart drawer refresh */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var bubble = document.querySelector('.cart-count-bubble');
            if (bubble) {
              var span = bubble.querySelector('[aria-hidden]') || bubble;
              span.textContent = cart.item_count;
            }
          });
        setTimeout(function () {
          btn.textContent = prev;
          btn.disabled = false;
        }, 1400);
      })
      .catch(function () {
        btn.textContent = prev;
        btn.disabled = false;
      });
  });

  /* Quick Buy — add to cart then go straight to checkout */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-moss-quick-buy]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    /* Supports either a static data-variant-id, or a live lookup via
       data-variant-input="elementId" (for pages with a variant picker). */
    var id = btn.dataset.variantId;
    if (btn.dataset.variantInput) {
      var variantEl = document.getElementById(btn.dataset.variantInput);
      if (variantEl) id = variantEl.value;
    }
    if (!id) return;

    var quantity = 1;
    if (btn.dataset.qtyInput) {
      var qtyEl = document.getElementById(btn.dataset.qtyInput);
      if (qtyEl) quantity = parseInt(qtyEl.value, 10) || 1;
    }

    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.textContent = prev;
        btn.disabled = false;
      });
  });

})();
